import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/esnext.map.get-or-insert.js";
import "core-js/modules/esnext.map.get-or-insert-computed.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";
import Icon from "@/components/icon/Icon.vue";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import QuestionAnswerImageUploader from "@/components/questions/QuestionAnswerImageUploader.vue";
import quizUtils from "@/util/quizUtils";
let ItemsSorting = class ItemsSorting extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "sortingItems", void 0);
    _defineProperty(this, "realtimeSortingItems", []);
    _defineProperty(this, "activeItem", null);
    _defineProperty(this, "displayItemDeletionDialog", false);
    // Drag-and-drop state
    _defineProperty(this, "dragStartIndex", null);
    _defineProperty(this, "dragOverIndex", null);
    _defineProperty(this, "isDraggable", true);
  }
  mounted() {
    this.initRealtimeItems(this.sortingItems);
  }
  onSortingItemsChanged(items) {
    this.initRealtimeItems(items);
  }
  get LABEL_NB_MAX_CHARS() {
    return quizUtils.QUIZ_LABELS_NB_MAX_CHARS;
  }
  initRealtimeItems(items) {
    this.realtimeSortingItems = structuredClone(items);
    this.realtimeSortingItems.sort((a, b) => a.position - b.position);
  }
  handleMouseDown(event) {
    const target = event.target;
    this.isDraggable = !target.closest('input');
  }
  onSortingItemBlur(item, value) {
    const newItem = value.trim();
    if (!item.image && newItem !== item.value?.trim()) {
      item.value = newItem;
      this.emitSortingItemsUpdated(item);
    } else if (item.image && newItem !== item.image.imageLabel?.trim()) {
      item.image.imageLabel = newItem;
      item.value = undefined;
      this.emitSortingItemsUpdated(item);
    }
  }
  deleteItem(itemToDelete) {
    if (this.realtimeSortingItems.length > 2) {
      this.setActiveItem(itemToDelete);
      this.displayItemDeletionDialog = true;
    }
  }
  onItemDeleteConfirm() {
    this.realtimeSortingItems = this.realtimeSortingItems.filter(item => item !== this.activeItem);
    this.renumberItemsPositions();
    this.emitSortingItemsUpdated();
    this.displayItemDeletionDialog = false;
    this.unsetActiveItem();
  }
  onItemDeleteCancel() {
    this.displayItemDeletionDialog = false;
    this.unsetActiveItem();
  }
  setActiveItem(itemToDelete) {
    this.activeItem = itemToDelete;
  }
  renumberItemsPositions() {
    this.realtimeSortingItems.forEach((item, index) => item.position = index + 1);
  }
  unsetActiveItem() {
    this.activeItem = null;
  }
  emitSortingItemsUpdated(item) {
    if (!this.duplicateItemsExist()) {
      this.$emit("sortingItemsUpdate", this.realtimeSortingItems, item);
    } else {
      WElMessage.showErrorMessage(this.$t('chapter.question.sorting.errorAlert.duplicateItems'));
    }
  }
  duplicateItemsExist() {
    const seen = new Map();
    let hasDuplicate = false;
    for (const sortingItem of this.realtimeSortingItems) {
      const val = sortingItem.value || sortingItem.image?.imageLabel;
      if (!val) continue;
      if (seen.has(val)) {
        // on marque le champ en doublon
        hasDuplicate = true;
        sortingItem.isValueError = true;
        // marquer aussi le premier trouvé
        const first = seen.get(val);
        if (first) {
          first.isValueError = true;
        }
      } else {
        sortingItem.isValueError = false;
        seen.set(val, sortingItem);
      }
    }
    return hasDuplicate;
  }
  onDragStart(index) {
    this.dragStartIndex = index;
    this.dragOverIndex = index;
  }
  onDragEnter(index) {
    this.dragOverIndex = index;
  }
  onDragEnd() {
    this.dragStartIndex = null;
    this.dragOverIndex = null;
  }
  onDrop(index) {
    if (this.dragStartIndex === null) return;
    const from = this.dragStartIndex;
    const to = index;
    if (from !== to) {
      const moved = this.realtimeSortingItems[from];
      const remaining = this.realtimeSortingItems.filter((_, i) => i !== from);
      remaining.splice(to, 0, moved);
      this.realtimeSortingItems = remaining;
      this.$nextTick(() => {
        this.renumberItemsPositions();
        this.emitSortingItemsUpdated();
      });
    }
    this.onDragEnd();
  }
  onAnswerImageChange(uploadedImage, sortingItem) {
    sortingItem.image = {
      imageName: uploadedImage.originalName,
      imageLabel: sortingItem.value,
      uploadTmpPath: uploadedImage.path
    };
    sortingItem.value = undefined;
    this.emitSortingItemsUpdated();
  }
  onImageDelete(sortingItem) {
    sortingItem.value = sortingItem.image?.imageLabel;
    sortingItem.image = undefined;
    sortingItem.isValueError = !sortingItem.value;
    if (sortingItem.value) {
      this.emitSortingItemsUpdated();
    }
  }
};
__decorate([Prop({
  default: []
})], ItemsSorting.prototype, "sortingItems", void 0);
__decorate([Watch("sortingItems")], ItemsSorting.prototype, "onSortingItemsChanged", null);
ItemsSorting = __decorate([Component({
  components: {
    QuestionAnswerImageUploader,
    ConfirmDialog,
    WInput,
    Icon
  },
  emits: ['sortingItemsUpdate']
})], ItemsSorting);
export default ItemsSorting;